import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {ModalContent} from '../ModalContent';
import {SectionLeft} from '../SectionLeft';
import {ContentDescription} from '../ContentDescription';
import {SectionRight} from '../SectionRight';
import {GelOrientation} from '../GelOrientation';
import {OrientationControlBlock} from '../OrientationControlBlock';
import {FullscreenModal} from '@learningblocks/storybook-components/lib/FullscreenModal';

import './style.scss';

export function GelOrientationModal(props) {

  const {t} = useTranslation();

  return (
    <FullscreenModal
      isOpen={props.isOpen}
      size={props.size}
      className='gel_orientation_modal'
      close={props.onClose}
      closeButton={true}
      notebookExpanded={props.notebookExpanded}
      lang={props.lang}
    >
      <div className="orientationModal">
        <ModalContent className='orientationModal_content'>
          <SectionLeft className='orientationModal_content_left'>
            <ContentDescription
              className='orientationModal_content_left_contentDescription'
              title={t('AlignTheGel.string')}
              description={t('OrientateGelInstruction.string')}
            />
            <OrientationControlBlock
              id={props.id}
              orientation={props.orientation}
              className='controlsModal_content_left_contents'
              lanes={props.lanes}
              decGelOrientation={props.decGelOrientation}
              incGelOrientation={props.incGelOrientation}
            />
          </SectionLeft>
          <SectionRight className='orientationModal_content_right'>
            <GelOrientation
              className='orientationModal_content_right_panel_top'
              lanes={props.lanes}
              alert={props.alert}
              orientation={props.orientation}
            />
          </SectionRight>
        </ModalContent>
      </div>
    </FullscreenModal>
  );
}

GelOrientationModal.propTypes = {
  /**
   * Function to alert event
   */
  alert: PropTypes.func,
  /**
   * Boolen to set if modal is displayed
   */
  isOpen: PropTypes.bool,
  /**
   * Function to invoke to close the modal
   */
  onClose: PropTypes.func,
  /**
   * Boolean to set if the Microcentrifuge tubes are balanced
   */
  balanced: PropTypes.bool,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
  /**
   * Boolean to determine if centrifuge runnable
   */
  centrifugeRunnable: PropTypes.bool,
};

GelOrientationModal.defaultProps = {
  showClose: true,
  size: 'md',
};
